interface ErrorStateProps {
  message?: string;
  onRetry?: () => void;
  /** The retry button's label (Story #28499 — the Monthly Billing Run's prototype says "Retry"). */
  retryLabel?: string;
}

export function ErrorState({ message = 'Something went wrong', onRetry, retryLabel = 'Try again' }: ErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <div className="mb-4 text-red-400">
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
        </svg>
      </div>
      <h3 className="text-sm font-medium text-gray-900">{message}</h3>
      {onRetry && (
        <button onClick={onRetry} className="mt-4 text-sm text-indigo-600 hover:text-indigo-800 font-medium">
          {retryLabel}
        </button>
      )}
    </div>
  );
}
